<template>
  <div>
    <mobile-col>
      <v-card :loading="isLoading">
        <v-card-title primary-title class="text-center d-block">
          <v-icon color="primary" x-large>{{ mdiShieldStarOutline }}</v-icon>
        </v-card-title>
        <v-card-title v-if="collegeDocument" primary-title class="text-center text-h2 d-block">
          {{ collegeDocument.title }}
        </v-card-title>
        <v-img v-if="collegeDocument" :src="collegeDocument.badge" />
        <v-card-text v-if="collegeExam">
          <div class="text-center text-h5 d-block">
            {{ $$t('score') }}
          </div>
          <div class="text-center d-block">
            <v-progress-circular
              :value="score"
              color="teal"
              :size="150"
              :width="15">
              {{ score }}
            </v-progress-circular>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn block color="primary" :to="{ name: 'membership-ListCollegeExam' }">
            {{ $$t('myExams') }}
          </v-btn>
        </v-card-actions>
        <v-card-actions>
          <back-button />
        </v-card-actions>
      </v-card>
      <div class="text-h2 text-center" color="primary">
      </div>
    </mobile-col>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiShieldStarOutline } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import MobileCol from '../components/MobileCol.vue';
import BackButton from '../components/BackButton.vue';

export default {
  components: { MobileCol, BackButton },
  mixins: [loading],
  name: 'CollegeExamCompleted',
  module: 'CollegeExam',
  data() {
    return {
      mdiShieldStarOutline,
      collegeExamId: this.$route.query.collegeExamId,
    };
  },
  computed: {
    ...mapState('collegeExams', ['collegeExam']),
    ...mapState('collegeDocuments', ['collegeDocument']),
    score() {
      return Math.round((this.collegeExam?.score ?? 0) * 100);
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    ...mapActions('collegeExams', ['LOAD_collegeExam']),
    ...mapActions('collegeDocuments', ['LOAD_collegeDocument']),
    async refresh() {
      this.isLoading = true;
      await this.LOAD_collegeExam(this.collegeExamId);
      await this.LOAD_collegeDocument(this.collegeExam.collegeDocumentId);
      this.isLoading = false;
    },
  },
};
</script>
